import React from 'react';
import './Services.css';
import serviceImg1 from '../../../images/react-2.svg';

const Services = () => {
    return (
        <>
            <section id="services">
                <div className="container">
                    <div className="section__header">
                        <h2 className="section__title">
                            Over the
                            <br />
                            past 2 years
                        </h2>
                        <p className="section__subtitle">
                        I've built products for companies and businesses around the globe ranging from marketing websites to complex solutions and enterprise apps with focus on fast, elegant and accessible user experiences.
                        </p>
                    </div>
                    <div className="services__box--wrapper">
                        <div className="row gy-4">
                            <div className="col-md-6 col-lg-4 col-12">
                                <div className="service__box">
                                    <img src={serviceImg1} alt="" className="service__thumbnail" />
                                    <h3 className="service__title">Product Design</h3>
                                    <p className="service__desc">
                                    I work with certain design tools to create high-fidelity designs and prototypes. I design accessible and usable products which aid business growth.
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 col-12">
                                <div className="service__box">
                                    <img src={serviceImg1} alt="" className="service__thumbnail" />
                                    <h3 className="service__title">Product Design</h3>
                                    <p className="service__desc">
                                    I work with certain design tools to create high-fidelity designs and prototypes. I design accessible and usable products which aid business growth.
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-4 col-12">
                                <div className="service__box">
                                    <img src={serviceImg1} alt="" className="service__thumbnail" />
                                    <h3 className="service__title">Product Design</h3>
                                    <p className="service__desc">
                                    I work with certain design tools to create high-fidelity designs and prototypes. I design accessible and usable products which aid business growth.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Services;